export default __webpack_public_path__ + "static/media/32.99cf5509.png";